module.exports = __webpack_public_path__ + "img/72_17.71c4c9ce.png";